import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from '../../../@core/services/data.service';
import { GridImagesInterface } from '../../../@core/models/site-data.model';
import * as Sentry from "@sentry/browser";
import { SiteModel } from '../../../@core/models/builder.model';
import { MatDialog } from '@angular/material/dialog';
import { MaterialDisplayImageComponent } from './display-image/display-image.component';


@Component({
  selector: 'app-grid-images-list',
  templateUrl: './grid-images-list.component.html',
  styleUrls: ['./grid-images-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MaterialGridImagesComponent implements OnInit {

  errorMessage: string;
  data: GridImagesInterface;
  active: boolean = false;
  backgroundColor: string = '';
  position: number = 0;
  sliderIndex: number = -1;
  positionField: number = undefined;
  test: string = '';
  images: string[] | string = [];
  adaptedImageSlider: any[] = [];
  style: string = '';
  isStock: string = '';
  activatePadding: boolean = false;
  maxWidth: string = '';
  title: string = '';
  titleSize: string = '';
  titleColor: string = '';
  site: SiteModel;
  siteName: string = '';
  imagesPerLine: number = 3
  timeOut;
  loading: boolean = true;
  allElementAnimation: string;
  textAnimation: string;
  itemsAnimation: string;
  fontWeight: string = '';

  constructor(
    private dialog: MatDialog,
    private dataService: DataService,
  ) {
  }

  ngOnInit() {
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.itemsAnimation = this.data.animation.items != '' ? this.data.animation.items : undefined;

    }
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "GridImagesComponent");
    });
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.itemsAnimation = this.data.animation.items != '' ? this.data.animation.items : undefined;

    }
    // this.initForm();
    this.siteName = this.dataService.site$.getValue().siteName;
    this.maxWidth = this.data.maxWidth ? this.data.maxWidth : "";
    this.titleSize = this.data.title ? this.data.titleSize : "large-title";
    this.title = this.data.title ? this.data.title : "";
    this.fontWeight = this.data.title ? this.data.fontWeight : "";
    this.images = this.data.images;
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : "";
    this.imagesPerLine = this.data.nbrImagesPerLine ? this.data.nbrImagesPerLine : 3;
    this.isStock = this.data.isStock;
    this.adaptedImageSlider = [];
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.dataService.getDefaultColor(this.backgroundColor);
    let itemsCount = 0;
    while (this.images.length > itemsCount) {
      for (let j = 0; j < this.imagesPerLine; j++) {
        if (this.images.length > itemsCount) {
          if (this.adaptedImageSlider[j]) {
            this.adaptedImageSlider[j].push(this.images[itemsCount]);
          } else {
            this.adaptedImageSlider.push([this.images[itemsCount]]);
          }
          itemsCount++;
        }
      }
    }
  }
  isString(val): boolean { return typeof val === 'string'; }

  updateUrl($event) {
    const src = $event.target.src;
    $event.target.src = 'https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/gallery/loading.gif';
    setTimeout(() => {
      $event.target.src = src;
    }, 8000);
  }

  openImage(image: string) {
    let data = { selectedImage: image, images: this.images };
    const dialogRef = this.dialog.open(MaterialDisplayImageComponent, { data, panelClass: 'grid-images-zoom' });
    dialogRef.afterClosed().toPromise().then();
  }
}
